<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 22/11/2023
  -->

<template>
	<div class="p-3 text-center">
		<div><h1>Online genogram maker</h1></div>
		<div>Interactive and intuitive drag&drop genogram maker. Add people, connect them using multiple social and emotional connections. Add multiple custom health conditions.</div>
		<div class="mb-4">On a mobile device?</div>
		<div class="mb-4">Please open this link on a desktop computer instead as it requires a bigger screen to work properly.</div>

		<div class="mb-4 bold">{{ this.currentUrl }}</div>

		<div>

			<!--				<qw-link-button :href="mailtoHref">Save to my Email Draft</qw-link-button>-->
			<span v-if="canShare">
					<div><qw-button type="primary" @click="onShareClicked">Share link to my computer</qw-button></div>
					<div>or</div>
				</span>
			<div>
				<qw-button @click="onCopyClicked">Copy the link</qw-button>
			</div>
			<!--				<div class="text-muted"><small>(requires a configured email client on your device)</small></div>-->

		</div>

	</div>
</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "MobileStopperScreen",
	extends: BaseComponent,

	methods: {
		async onShareClicked() {
			console.log("window.navigator = ", window.navigator)
			if (this.canShare) {
				await window.navigator.share({
					title: 'Interactive coaching tool - Open when on my desktop',
					url: this.currentUrl
				})
			} else {
				// fallback
			}
		},

		async onCopyClicked() {
			await this.copyToClipboard(this.currentUrl)
		},
	},

	computed: {
		currentUrl() {
			return window.location.href
		},

		canShare() {
			return !!window.navigator.share
		},

		mailtoHref() {
			return `mailto:draft@draft.com?subject=Open when on my desktop - Interactive tool for coaching&body=${this.currentUrl}`
		}
		},
}
</script>

<style lang="scss">

</style>
